import { TChatAction } from '../actions';

export interface IOfferChatsState {
  isChatsEnabled: boolean;
  isChatMessageSent: boolean;
  chatId?: string;
}

const initialState: IOfferChatsState = {
  chatId: undefined,
  isChatMessageSent: false,
  isChatsEnabled: false,
};

export function chatReducer(state: IOfferChatsState = initialState, action: TChatAction): IOfferChatsState {
  switch (action.type) {
    case 'IChatMessageSent':
      return {
        ...state,
        isChatMessageSent: true,
      };

    case 'IChatsStateReceived':
      return {
        ...state,
        isChatsEnabled: action.payload.enabled,
      };

    case 'IOfferChatReceived':
      return {
        ...state,
        chatId: action.payload.chatId,
      };

    default:
      return state;
  }
}
